/// <reference types="vite/client" />

import * as Sentry from '@sentry/browser'

Sentry.init({
  dsn: 'https://b4e04133915727b16c8d1e5f91f36662@o4505970536349696.ingest.us.sentry.io/4509001340747776',
  environment: import.meta.env.VITE_VERCEL_ENV ?? 'local',
  integrations: [
    Sentry.browserTracingIntegration({
      instrumentNavigation: false,
      enableLongTask: true,
    }),
  ],
  release: import.meta.env.VITE_VERCEL_GIT_COMMIT_SHA ?? 'local-or-unknown',
  tracesSampleRate: 0.01, // 1% of traces will be sampled
  maxBreadcrumbs: 50,
  normalizeDepth: 5,
  sendClientReports: true,
});